module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--fr@2-b64bc1dbd2206fa62f1e769eb6d30b2e.jpg";